import React, { useState, useEffect } from 'react';
import { ChevronLeft, ChevronRight, Star, Quote } from 'lucide-react';
import '../Css_files/Slider.css';

const TestimonialSlider = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [isAutoPlaying, setIsAutoPlaying] = useState(true);

  const testimonials = [
    {
      name: "Sarah Johnson",
      role: "Mechanical Engineer",
      company: "Google",
      image: "https://images.pexels.com/photos/774909/pexels-photo-774909.jpeg?auto=compress&cs=tinysrgb&w=400&h=400&fit=crop",
      content: "Profenaa’s hands-on approach in mechanical CAD and manufacturing tools helped me gain real-world exposure. Today, I feel confident working in any production environment.",
      rating: 5,
      course: "Full Stack Development"
    },
    {
      name: "Michael Chen",
      role: "civil Engineer",
      company: "Apple",
      image: "https://images.pexels.com/photos/1043471/pexels-photo-1043471.jpeg?auto=compress&cs=tinysrgb&w=400&h=400&fit=crop",
      content: "Learning software like AutoCAD and Revit at Profenaa was a turning point. The training was not just theoretical it made me industry-ready from day one.",
      rating: 5,
      course: "UI/UX Design Mastery"
    },
    {
      name: "Emily Rodriguez",
      role: "Ece Engineer",
      company: "Netflix",
      image: "https://images.pexels.com/photos/1181686/pexels-photo-1181686.jpeg?auto=compress&cs=tinysrgb&w=400&h=400&fit=crop",
      content:"The embedded systems and PCB design training helped me build real-time projects. The practical knowledge I gained here is something my college never gave.",
      rating: 5,
      course: "Data Science & Analytics"
    },
    {
      name: "David Thompson",
      role: "Mobile App Developer",
      company: "Uber",
      image: "https://images.pexels.com/photos/1222271/pexels-photo-1222271.jpeg?auto=compress&cs=tinysrgb&w=400&h=400&fit=crop",
      content: "EduPro's Mobile Development course gave me the skills to build scalable apps. The React Native and Flutter modules were incredibly detailed. Now I'm developing apps used by millions of users at Uber.",
      rating: 5,
      course: "Mobile App Development"
    },
    {
      name: "Lisa Wang",
      role: "Digital Marketing Director",
      company: "Amazon",
      image: "https://images.pexels.com/photos/1239291/pexels-photo-1239291.jpeg?auto=compress&cs=tinysrgb&w=400&h=400&fit=crop",
      content: "The Digital Marketing program is comprehensive and practical. I learned everything from SEO to performance marketing. The strategies I learned helped me increase conversion rates by 300% in my current role at Amazon.",
      rating: 5,
      course: "Digital Marketing Pro"
    },
    {
      name: "James Wilson",
      role: "Cybersecurity Analyst",
      company: "Microsoft",
      image: "https://images.pexels.com/photos/1681010/pexels-photo-1681010.jpeg?auto=compress&cs=tinysrgb&w=400&h=400&fit=crop",
      content: "The Cybersecurity program at EduPro is world-class. The ethical hacking modules and hands-on labs prepared me for real-world security challenges. I'm now protecting Microsoft's infrastructure thanks to this training.",
      rating: 5,
      course: "Cybersecurity Specialist"
    }
  ];

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % testimonials.length);
  };

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev - 1 + testimonials.length) % testimonials.length);
  };

  const goToSlide = (index) => {
    setCurrentSlide(index);
  };

  useEffect(() => {
    if (isAutoPlaying) {
      const interval = setInterval(nextSlide, 5000);
      return () => clearInterval(interval);
    }
  }, [isAutoPlaying]);

  return (
    <section id="testimonials" className="testimonial-slider">
      <div className="container">
        <div className="testimonials-header">
          <h2 className="section-title">
            What Our <span className="highlight">Students Say</span>
          </h2>
          <p className="section-description">
            Real success stories from our graduates who have transformed their careers 
            and are now working at top companies worldwide.
          </p>
        </div>
        
        <div 
          className="slider-container"
          onMouseEnter={() => setIsAutoPlaying(false)}
          onMouseLeave={() => setIsAutoPlaying(true)}
        >
          <div className="slider-wrapper">
            <div 
              className="slides-container"
              style={{ transform: `translateX(-${currentSlide * 100}%)` }}
            >
              {testimonials.map((testimonial, index) => (
                <div key={index} className="slide">
                  <div className="testimonial-content">
                    <div className="testimonial-left">
                      <div className="testimonial-image">
                        <img src={testimonial.image} alt={testimonial.name} />
                        <div className="image-overlay">
                          <Quote className="quote-icon" />
                        </div>
                      </div>
                    </div>
                    
                    <div className="testimonial-right">
                      <div className="testimonial-header">
                        <div className="rating">
                          {[...Array(testimonial.rating)].map((_, i) => (
                            <Star key={i} className="star filled" />
                          ))}
                        </div>
                        <div className="course-badge">{testimonial.course}</div>
                      </div>
                      
                      <blockquote className="testimonial-text">
                        "{testimonial.content}"
                      </blockquote>
                      
                      <div className="testimonial-author">
                        <h4 className="author-name">{testimonial.name}</h4>
                        <p className="author-role">{testimonial.role}</p>
                        <p className="author-company">{testimonial.company}</p>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
          
          <button className="slider-btn prev-btn" onClick={prevSlide}>
            <ChevronLeft />
          </button>
          <button className="slider-btn next-btn" onClick={nextSlide}>
            <ChevronRight />
          </button>
          
          <div className="slider-dots">
            {testimonials.map((_, index) => (
              <button
                key={index}
                className={`dot ${index === currentSlide ? 'active' : ''}`}
                onClick={() => goToSlide(index)}
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default TestimonialSlider;